import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import noUiSlider from 'nouislider';
import { gtmPushEvent } from '~/helpers/gtm';
import { useSearchFacets } from '~/composables/_next/useSearchFacets';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFilterRangeOrganism',
  props: {
    facetId: null,
    options: null
  },
  setup: function setup(__props) {
    var _query$toString, _query, _query$toString2, _query2;
    var props = __props;
    var _useSearchFacets = useSearchFacets(),
      updateSearchFacets = _useSearchFacets.updateSearchFacets;
    var _useRoute = useRoute(),
      query = _useRoute.query;
    var sliderElRef = ref(null);
    var sliderRef = ref(null);
    var range = ref([(_query$toString = (_query = query["min-".concat(props.facetId)]) === null || _query === void 0 ? void 0 : _query.toString()) !== null && _query$toString !== void 0 ? _query$toString : props.options.min, (_query$toString2 = (_query2 = query["max-".concat(props.facetId)]) === null || _query2 === void 0 ? void 0 : _query2.toString()) !== null && _query$toString2 !== void 0 ? _query$toString2 : props.options.max]);
    var noUiSliderConfig = {
      start: range.value,
      range: {
        min: props.options.min,
        max: props.options.max
      },
      step: 1,
      margin: 1,
      connect: true,
      direction: 'ltr',
      orientation: 'horizontal',
      behaviour: 'tap-drag',
      keyboardSupport: true
    };

    /**
     * Initializes the noUiSlider library.
     */
    function initNoUiSlider() {
      sliderRef.value = noUiSlider.create(sliderElRef.value, noUiSliderConfig);
      sliderRef.value.on('change', function (values) {
        onRangeChange(values);
      });
    }

    /**
     * Called on range change.
     *
     * @param      {((string|number)[])}  values  The values
     */
    function onRangeChange(_x) {
      return _onRangeChange.apply(this, arguments);
    }
    function _onRangeChange() {
      _onRangeChange = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
        var _values$map, _values$map2, v1, v2, max, min;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _values$map = values.map(function (n) {
                return Number(n);
              }), _values$map2 = _slicedToArray(_values$map, 2), v1 = _values$map2[0], v2 = _values$map2[1];
              max = Math.max(v1, v2);
              min = Math.min(v1, v2);
              range.value = [min, max];
              // Convert min and max values to cents and update the query parameters.
              _context.next = 6;
              return updateSearchFacets(_defineProperty(_defineProperty({}, "max-".concat(props.facetId), max), "min-".concat(props.facetId), min));
            case 6:
              gtmPushEvent('filter', {
                event: 'generic_event',
                event_category: 'engagement',
                event_action: 'click',
                event_label: 'filter',
                event_name: 'generic_event',
                filter: {
                  name: props.facetId,
                  min: min,
                  max: max
                }
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _onRangeChange.apply(this, arguments);
    }
    onMounted(function () {
      initNoUiSlider();
    });
    onBeforeUnmount(function () {
      var _sliderRef$value;
      (_sliderRef$value = sliderRef.value) === null || _sliderRef$value === void 0 ? void 0 : _sliderRef$value.destroy();
    });
    return {
      __sfc: true,
      props: props,
      updateSearchFacets: updateSearchFacets,
      query: query,
      sliderElRef: sliderElRef,
      sliderRef: sliderRef,
      range: range,
      noUiSliderConfig: noUiSliderConfig,
      initNoUiSlider: initNoUiSlider,
      onRangeChange: onRangeChange
    };
  }
});